import { useState } from 'react';
import { useNavigate } from 'react-router';
import CompanyGrid from './CompanyGrid';
import CompanyListingService from './CompanyListingService';
import SearchCriteria from './SearchCriteria';

interface LayoutProps {
    companyList: any[];
    searchCriteria: any;
    setCompanyList: (list: any[]) => void;
    setSearchCriteria: (criteria: any) => void;
}

const Layout = ({ companyList, searchCriteria, setCompanyList, setSearchCriteria }: LayoutProps) => {
    const navigate = useNavigate();
    const [showSearchCriteria, setShowSearchCriteria] = useState(true);
    const [fuzzySearchText, setFuzzySearchText] = useState('');

    const handleFuzzySearch = async (event: React.FormEvent) => {
        event.preventDefault();
        try {
            const criteria = { ...searchCriteria, name: fuzzySearchText };
            const response = await CompanyListingService.search(criteria);
            setCompanyList(response.data ?? []);
        } catch (error) {
            console.error('Search error:', error);
        }
    };

    return (
        <div className="main flex-1">
            <section className="updateadditionalinformation">
                <div className="container max-1140 px-lg-0 overflow-hidden">
                    <div className="row">
                        <div className="col-md-12 mb-4">
                            <div className="white-block white-block-notopborderradius p-0 h-100">
                                <div className="p-4 p-md-5">
                                    <div className="alumni_statistics">
                                        <div className="d-flex justify-content-between align-items-center mb-3 pb-2">
                                            <h3 className="font-35 font-600 mb-0">Manage Companies</h3>
                                            <div className="dashboard innerpage smart-scroll scrolled-down">
                                                <button
                                                    className="btn btn-green"
                                                    onClick={() => navigate('/company/add-new')}>
                                                    <span>Add Company</span>
                                                </button>
                                            </div>
                                        </div>

                                        <div className="d-flex flex-wrap justify-content-between align-items-start align-items-md-center mb-2 filterSearch">
                                            <div className="d-flex flex-wrap flex-1 mb-0 justify-content-start">
                                                <button
                                                    className="btn-grpfiter me-3"
                                                    type="button"
                                                    onClick={() => setShowSearchCriteria(!showSearchCriteria)}>
                                                    <i className="icon-filter font-13 me-2"></i>
                                                    Filters
                                                </button>
                                                <div className="search alumniSearch m-0 open position-static flex-1 mb-2">
                                                    <form
                                                        className="form-inline d-flex flex-wrap justify-content-between d-block"
                                                        onSubmit={handleFuzzySearch}>
                                                        <input
                                                            value={fuzzySearchText}
                                                            placeholder="Search by company name"
                                                            aria-label="Search"
                                                            className="form-control flex-1 font-13 font-500 text-truncate"
                                                            onChange={(e) => setFuzzySearchText(e.target.value)}
                                                        />
                                                        <button className="btn btn-search icon icon-search"></button>
                                                    </form>
                                                </div>
                                            </div>
                                            <div className="d-flex flex-wrap align-items-center justify-content-end">
                                                <h3 className="font-14 font-500 mb-0 me-2">
                                                    Total {companyList.length.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} records
                                                </h3>
                                            </div>
                                        </div>

                                        {showSearchCriteria && (
                                            <SearchCriteria
                                                searchCriteria={searchCriteria}
                                                setSearchCriteria={setSearchCriteria}
                                                setCompanyList={setCompanyList}
                                            />
                                        )}

                                        <CompanyGrid
                                            companyList={companyList}
                                            setCompanyList={setCompanyList}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Layout;
